module.exports = __webpack_public_path__ + "static/media/tutorial-macros-background.1cdfac08.svg";